import React from 'react';

const TxtBase = ({ children }) => {
    return (
        <div className='text-base text-primary-dark-s3l6 dark:text-primary-light-s3l6'>
            {children}
        </div>
    );
};

export default TxtBase